import { call, put, takeLatest, select } from 'redux-saga/effects';

import { MODAL_LOGIN } from '../../../constants/app';
import { userApi } from '../../../api';

import { updateQueryString } from '../../router/actions';
import { pushNotification } from '../../ui/actions';
import * as actions from './actions';

import { selectSecret } from '../../router/selectors';

function* resetPassword({ password }) {
  try {
    yield put({ type: actions.PASSWORD_RESET_PENDING });
    const secret = yield select(selectSecret);
    const payload = {
      secret,
      password,
    };
    const { status } = yield call(userApi.resetPassword, payload);

    if (status === 200) {
      yield put({ type: actions.PASSWORD_RESET_FULFILLED });
      yield put(updateQueryString({ modal: MODAL_LOGIN, secret: undefined }));
      yield put(
        pushNotification({
          title: 'Password changed successfully!',
          type: 'success',
          duration: 6,
        }),
      );
    }
  } catch (e) {
    yield put({ type: actions.PASSWORD_RESET_REJECTED, payload: e });
  }
}

export function* watchResetPassword() {
  yield takeLatest(actions.PASSWORD_RESET, resetPassword);
}
